module.exports = __webpack_public_path__ + "img/HQ-OA-360V04NGL.d3d695c0.jpg";